import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class WalletGuard implements CanActivate {
  
  constructor(public configService: ConfigService) {}

  async canActivate(): Promise<boolean> {
    await this.configService.getInitialInfo().then((response) => {
      return response;
    });
    return await this.configService.company_info.wallet_active;
  }
  
}
